export default __webpack_public_path__ + "7efe19e13b415edf1d6a318e5902823f.svg";